import React from 'react';
import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Select} from 'antd';
import {toJS} from 'mobx';
import styles from '../style.module.scss';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';

interface Props {
  isSubscriber: boolean;
  store: CurrentPageStore;
  setCompetitors: (competitors: any[]) => void;
  setActiveKw: React.Dispatch<React.SetStateAction<string>>;
  activeKw: string;
  compListCollapsed: boolean;
}

export const KeywordSelector = ({store, isSubscriber, setActiveKw, setCompetitors, activeKw, compListCollapsed}: Props) => {
  const {Option} = Select;

  const handleOnSelectChange = value => {
    setActiveKw(value);
    setCompetitors(toJS(store?.analytics?.competitorsData)?.filter(item => item.keyword === value)[0]?.competitors);
  };

  return <div>
    <div>
      {compListCollapsed ? 'Kw' : 'Keyword'}
    </div>
    <Select
      disabled={!isSubscriber}
      value={`${activeKw}`}
      defaultValue={activeKw}
      onSelect={value => handleOnSelectChange(value)}
      dropdownStyle={{minWidth: '250px', fontSize: '12px'}}
      dropdownClassName={styles.keywordDropdownList}
      className={classNames(styles.selectInput, compListCollapsed && styles.minified)}
      suffixIcon={<FontAwesomeIcon icon={faCaretDown} style={{color: '#000', marginLeft: 0}}/>}
    >
      {toJS(store?.analytics?.competitorsData)?.map(item => {
        return <Option key={item.keyword} value={item.keyword}>{item.keyword}</Option>;
      })}

    </Select>
  </div>;
};
